import React, { MutableRefObject, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useTestId } from '../../hooks/useTestId';
import { IThemePalette } from '../../Themes/interfaces';

const TOOLTIP_DEFAULT_Z_INDEX = 100;

export const tooltipColours = (palette: IThemePalette) => ({
  tooltip: { background: palette.neutral.gray[100] }
});

interface ITooltipContainerProps {
  zIndex: number;
  width: number;
}

export interface ITooltipProps {
  visible?: boolean;
  parentRef: MutableRefObject<HTMLElement | null>;
  onClickOutside?: () => void;
  triggerRef?: MutableRefObject<HTMLElement | null>;
  width?: number;
}

const TooltipContainer = styled.div<ITooltipContainerProps>`
  z-index: ${({ zIndex }) => zIndex};
  width: ${({ width }) => `${width}px`};
  display: block;
  position: absolute;
`;

export const Tooltip: React.FC<ITooltipProps> = ({ children, visible, onClickOutside, parentRef, triggerRef = parentRef, width, ...rest }) => {
  const tooltipRef = useRef<HTMLDivElement | null>(null);
  const { generateTestId } = useTestId(rest, 'Tooltip');

  const handleClickOutside = (e: MouseEvent) => {
    if (onClickOutside && !tooltipRef.current?.contains(e.target as HTMLElement) && !triggerRef.current?.contains(e.target as HTMLElement)) {
      onClickOutside();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!parentRef.current || !visible) {
    return <></>;
  }

  const { left: parentLeft, right: parentRight } = parentRef.current.getBoundingClientRect();

  // TODO: Add useZIndex hook here
  return (
    <TooltipContainer ref={tooltipRef} zIndex={TOOLTIP_DEFAULT_Z_INDEX} width={width ?? parentRight - parentLeft} {...generateTestId()}>
      {children}
    </TooltipContainer>
  );
};
